/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.concat.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import Previewer from "vux/src/components/previewer/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import { apimessageList } from '@/api';
import AddMssage from './AddMssage';
import UserLogo from '@/components/UserLogo';
import ScrollerList from '@/components/ScrollerList';
import FlowList from '@/components/ScrollerList/FlowList';
export default {
  name: 'message',
  components: {
    ViewBox: ViewBox,
    XButton: XButton,
    AddMssage: AddMssage,
    UserLogo: UserLogo,
    Previewer: Previewer,
    ScrollerList: ScrollerList,
    FlowList: FlowList
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    id: {
      require: true
    },
    customer_id: {
      require: true
    }
  },
  data: function data() {
    return {
      list: [],
      showAddMssage: false,
      currValue: [],
      pageIndex: 0,
      pageSize: 10,
      imglist: []
    };
  },
  computed: {
    imgUrlsForPreviewer: function imgUrlsForPreviewer() {
      return this.currValue.map(function (item) {
        return {
          src: item
        };
      });
    },
    scrollerHight: function scrollerHight() {
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - 50 - 4 * fontSize - 40 + 50;
    }
  },
  created: function created() {
    this.loadList(true);
  },
  methods: {
    loadList: function loadList() {
      var _this = this;
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var operation = arguments.length > 1 ? arguments[1] : undefined;
      if (reset) {
        this.pageIndex = 0;
        this.$vux.loading.show({
          text: i18n.tc("206")
        });
      }
      var params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        project_id: this.id
      };
      return new Promise(function (resolve, reject) {
        apimessageList(params).then(function (res) {
          resolve(res);
          if (!reset) {
            _this.list = Object.freeze([].concat(_toConsumableArray(_this.list), _toConsumableArray(res.data)));
          } else {
            _this.list = Object.freeze(res.data);
            setTimeout(function () {
              _this.$vux.loading.hide();
            }, 300);
          }
        });
      });
    },
    // 下拉刷新
    onPulldownLoading: function onPulldownLoading() {
      var _this2 = this;
      this.loadList(true).then(function () {
        _this2.$refs['orderList'].donePulldown();
      });
    },
    // 上拉加载
    onPullupLoading: function onPullupLoading() {
      var _this3 = this;
      this.pageIndex = this.pageIndex + 1;
      this.loadList().then(function (res) {
        if (res.data.length === 0) {
          _this3.$refs['orderList'].disablePullup();
        } else {
          _this3.$refs['orderList'].donePullup();
        }
      });
    },
    showPic: function showPic(list, i) {
      var _this4 = this;
      this.imglist = list.map(function (v) {
        return {
          src: v.file_url
        };
      });
      this.$nextTick(function () {
        _this4.$refs['previewer'].show(i);
      });
    }
  }
};